import React from 'react'
import { styled } from '@fareye/ui'
import { Span } from './Timeline/styled'
import { toTileCase } from '@fareye/utils'
interface IStoryLine {
  story: any[]
  isDate?: boolean
  textStyle?: any
  textFontSize?: string
  noBoldText?: Boolean
}
const StartDot = styled.div`
  box-sizing: border-box;
  height: 8px;
  width: 8px;
  border: 1px solid #212121;
  border-radius: 50%;
`
const EndDot = styled.div`
  box-sizing: border-box;
  height: 8px;
  width: 8px;
  border-radius: 50%;
  background: black;
  flex-shrink: 0;
`
const StoryLineContainer = styled.div`
  display: flex;
  flex-direction: column;
`
const DotContainer = styled.div`
  display: flex;
  align-items: center;
`
const DottedLine = styled.div`
  height: 15px;
  border-right: 2px dotted black;
  margin: 2px;
  width: 0px;
`
const Text = styled(Span)`
  font-size: 12px;
  color: #212121;
  font-family: 'Roboto';
  font-weight: 500;
  margin-left: 5px;
  ${(props: any) => props.styles}
`
export default function StoryLine({
  story,
  isDate = false,
  textStyle,
  textFontSize,
  noBoldText
}: IStoryLine) {
  return (
    <StoryLineContainer>
      {story.map((ele, index) => (
        <React.Fragment key={index}>
          <DotContainer>
            {index === story.length - 1 ? <EndDot /> : <StartDot />}{' '}
            <Text
              variant="ellipsis"
              style={{
                fontSize: textFontSize ? textFontSize : '12px',
                fontWeight: noBoldText ? 'normal' : '500',
                ...textStyle
              }}
            >
              {ele ? (isDate ? ele : toTileCase(ele)) : ''}
            </Text>
          </DotContainer>
          {index === story.length - 1 ? '' : <DottedLine />}
        </React.Fragment>
      ))}
    </StoryLineContainer>
  )
}
